import { useEffect } from 'react';
import 'aos/dist/aos.css';
import AOS from 'aos';

import './App.css';
import Carrusel from './Componentes/carrusel';
import Codigo1 from './Componentes/codigoshigh';
import Acordeon from './Componentes/acordeon';
import SEO from './Componentes/seo';

import img01 from './Imgs/imgcohete.png';
import img02 from './Imgs/imgbase.png';

function Home() {
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "Person",
      name: "Juan Camilo Muñoz",
      jobTitle: "Desarrollador Web",
      description:
        "Desarrollador web especializado en React, Node.js, frontend, backend y soluciones digitales para clientes en Colombia.",
      url: "https://portafoliojcmr.netlify.app/",
      image: "https://portafoliojcmr.netlify.app/imgs/foto.jpg",
      sameAs: [
        "https://www.linkedin.com/in/juancamilomunozr/",
        "https://github.com/"
      ],
      knowsAbout: [
        "React",
        "Node.js",
        "Frontend",
        "Backend",
        "Desarrollo web"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "JCMR Portafolio",
      url: "https://portafoliojcmr.netlify.app/",
      description:
        "Portafolio profesional de Juan Camilo Muñoz, desarrollador web especializado en React, Node.js, frontend y backend."
    }
  ];

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  const enviar1 = () => {
    window.location.href = "https://viteportafoliojcmr.netlify.app/";
  }

  const enviar2 = () => {
    window.location.href = "https://dataprocontrol.com/";
  }

  const enviar3 = () => {
    window.location.href = "https://portafoliojcmr.netlify.app/";
  }

  return (
    <>
      <SEO
        title="Juan Camilo Muñoz, Desarrollador Web React y Node.js en Colombia"
        description="Portafolio profesional de Juan Camilo Muñoz, desarrollador web enfocado en crear sitios y aplicaciones con React, Node.js, frontend, backend y soluciones digitales para negocios."
        path="/"
        keywords={[
          "Juan Camilo Muñoz",
          "desarrollador web Colombia",
          "portafolio React",
          "Node.js",
          "frontend",
          "backend",
          "soluciones digitales"
        ]}
        structuredData={structuredData}
      />
      <div className='app1' data-aos="fade-up">
        <div className='app1-1' data-aos="fade-right">
          <span className='span1App1-1' data-aos="zoom-in">Manejo de Backend</span>
          <span className='span2App1-1' data-aos="fade-up">Rápido, escalable, personalizado</span>
          <span className='span3App1-1' data-aos="fade-up">Desarrollo de aplicaciones web rápidas y escalables utilizando Node.js con Express</span>
          <button className='buton1App1-1' onClick={enviar1} data-aos="zoom-in-up">Demo</button>
        </div>
        <div className='app1-2' data-aos="fade-left">
          <Codigo1 />
        </div>
      </div>

      <div className='app2' data-aos="fade-up">
        <div className='app2-1' data-aos="fade-right">
          <Carrusel />
        </div>
        <div className='app2-2' data-aos="fade-left">
          <span className='span0App2-2'><img src={img02} alt='imgbase' /></span>
          <span className='span1App2-2'>Manejo de base de datos</span>
          <span className='span2App2-2'>FreeSQL, Azure y WIxData</span>
          <span className='span3App2-2'>Control total de tus datos con CRUD</span>
          <button className='buton1App1-1' onClick={enviar2}>Demo</button>
        </div>
      </div>

      <div className='app3' data-aos="fade-up">
        <div className='app3-1' data-aos="fade-right">
          <img src={img01} alt='imgcohete' />
          <span className='span1App3-1'>Manejo de Frontend</span>
          <span className='span2App3-1'>REACT, CSS y HTML</span>
          <span className='span3App3-1'>Diseños web con gran calidad visual</span>
          <button className='buton1App1-1' onClick={enviar3}>Demo</button>
        </div>
        <div className='app3-2' data-aos="fade-left">
          <Acordeon />
        </div>
      </div>
    </>
  );
}

export default Home;
